/* Produktfragen (PDP). Backend: Cloudflare Worker (GET /questions, POST /ask als SSE).
   Inline-Block = Einstieg; Antworten erscheinen im Chat-Panel (Desktop: links, nicht-modal; Mobil: Vollbild, modal).
   Das Panel-DOM stammt aus dem <template data-mkpq-template> und wird erst beim ersten Oeffnen erzeugt.
   Antworttext wird nie als HTML eingefuegt, nur per DOM-Knoten/textContent. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mkpq]');
  if (!root || root.getAttribute('data-mkpq-init')) return;
  root.setAttribute('data-mkpq-init', '1');

  var base = (root.getAttribute('data-worker') || '').replace(/\/+$/, '');
  var pid = root.getAttribute('data-product-id');
  if (!base || !pid) return;

  var tpl = document.querySelector('[data-mkpq-template]');
  var pillsEl = root.querySelector('[data-mkpq-pills]');
  var resumeBtn = root.querySelector('[data-mkpq-resume]');
  var countEl = root.querySelector('[data-mkpq-count]');
  var form = root.querySelector('[data-mkpq-form]');
  var input = form.querySelector('input');
  var sendBtn = form.querySelector('button');

  var panel = null, chatEl = null, pScroll = null, pPills = null, pInput = null, pSend = null, pTitle = null;
  var busy = false, started = false, asked = 0, stick = true;
  var suggestions = [];
  var lastTrigger = null, locked = false, lockY = 0, savedBody = null;
  var INTERRUPTED = '(Antwort unterbrochen – bitte versuch es noch einmal.)';
  var RATE = 'Du hast gerade viele Fragen gestellt – bitte warte einen Moment und versuch es dann noch einmal.';
  var TIMEOUT_MS = 30000;
  var MAX_MSGS = 20;
  var hist = [];
  var FRIENDLY = 'Gerade kann ich keine Fragen beantworten. Schreib uns gern an support@markenkoffer.de.';
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };

  function isDesk() { return !!mq.matches; }
  function isOpen() { return !!panel && !panel.hidden; }

  function ga(name, params) {
    try {
      /* Nur mit Statistik-Einwilligung (Shopify Customer Privacy API), sonst kein Event */
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return;
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else if (window.dataLayer) { var o = { event: name }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o); }
    } catch (e) { /* still */ }
  }
  function track(source) { ga('product_qa_ask', { source: source, product_id: pid }); }

  /* ---------- Zustand/Pills ---------- */
  function setBusy(b) {
    busy = b;
    sendBtn.disabled = b;
    if (pSend) pSend.disabled = b;
    if (chatEl) chatEl.setAttribute('aria-busy', b ? 'true' : 'false');
    Array.prototype.forEach.call(root.querySelectorAll('.mkpq__pill'), function (x) { x.disabled = b; });
    if (panel) Array.prototype.forEach.call(panel.querySelectorAll('.mkpq__pill'), function (x) { x.disabled = b; });
  }

  function fillPills(container, max) {
    while (container.firstChild) container.removeChild(container.firstChild);
    var n = 0;
    suggestions.forEach(function (s) {
      if (s.used || n >= max) return;
      n++;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mkpq__pill';
      b.textContent = s.label;
      b.disabled = busy;
      b.addEventListener('click', function (e) { ask(s.label, 'suggested', s, e.detail === 0, b); });
      container.appendChild(b);
    });
  }
  function renderPills() {
    fillPills(pillsEl, 3);
    if (pPills) fillPills(pPills, 2);
    resumeBtn.hidden = asked === 0;
    countEl.textContent = asked ? '(' + asked + ')' : '';
  }

  /* ---------- Rendering (nur DOM-Knoten) ---------- */
  /* Markdown-Subset: **fett**, [Text](URL), nackte URLs. Alles per DOM-Knoten; nur markenkuffer.com-Links. */
  var TOK_SRC = /\*\*([\s\S]+?)\*\*|\[([^\]\n]*)\]\(([^)\s]*)\)|(https:\/\/www\.markenkoffer\.de\/[^\s<>"'()\[\]*]*)/.source;
  var SVGNS = 'http://www.w3.org/2000/svg';
  function safeUrl(url) {
    try {
      var u = new URL(url);
      if (u.origin !== 'https://markenkuffer.com' || u.username !== '' || u.password !== '') return null;
      if (url.indexOf(String.fromCharCode(92)) >= 0 || u.pathname.indexOf('//') >= 0) return null;
      if (!/^\/(products|blogs|pages|collections)\/[^\/]/.test(u.pathname)) return null;
      return u;
    } catch (e) { return null; }
  }
  function makeLink(parent, u, label, plain) {
    var a = document.createElement('a');
    a.href = u.href;
    a.rel = 'noopener';
    if (/^\/blogs\//.test(u.pathname)) {
      var svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('class', 'mkpq__ico');
      svg.setAttribute('width', '14'); svg.setAttribute('height', '14'); svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      var path = document.createElementNS(SVGNS, 'path');
      path.setAttribute('d', 'M4 5a2 2 0 0 1 2-2h13v15H6a2 2 0 0 0-2 2V5zm2 13h13M8 7h7');
      path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '2');
      path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      a.appendChild(svg);
    }
    if (plain) a.appendChild(document.createTextNode(label));
    else appendInline(a, label, true);
    parent.appendChild(a);
  }
  function appendInline(parent, text, inLink) {
    var last = 0, m;
    var re = new RegExp(TOK_SRC, 'g');
    while ((m = re.exec(text)) !== null) {
      if (m.index > last) parent.appendChild(document.createTextNode(text.slice(last, m.index)));
      last = m.index + m[0].length;
      if (m[1] !== undefined) {
        var st = document.createElement('strong');
        appendInline(st, m[1], inLink);
        parent.appendChild(st);
      } else if (m[3] !== undefined) {
        var u = inLink ? null : safeUrl(m[3]);
        if (u) makeLink(parent, u, m[2] || 'Link', false);
        else appendInline(parent, m[2], inLink);
      } else {
        var url = m[4].replace(/[.,;:!?]+$/, '');
        var rest = m[4].slice(url.length);
        var u2 = inLink ? null : safeUrl(url);
        if (u2) {
          var lbl = 'Link';
          try { lbl = decodeURIComponent(u2.pathname.replace(/\/$/, '').split('/').pop() || '') || 'Link'; } catch (e) { /* still */ }
          makeLink(parent, u2, lbl.length > 40 ? lbl.slice(0, 37) + '\u2026' : lbl, true);
        } else parent.appendChild(document.createTextNode(url));
        if (rest) parent.appendChild(document.createTextNode(rest));
      }
    }
    if (last < text.length) parent.appendChild(document.createTextNode(text.slice(last)));
  }

  /* ---------- Produktkarten (cards-Event): nur DOM-Knoten, URL- und Bild-Whitelist ---------- */
  function safeImg(src) {
    try {
      var u = new URL(src);
      return (u.origin === 'https://cdn.shopify.com' && u.protocol === 'https:') ? u.href : null;
    } catch (e) { return null; }
  }
  function buildCards(items) {
    var strip = document.createElement('div');
    strip.className = 'mkpq__cards';
    strip.setAttribute('role', 'list');
    items.slice(0, 6).forEach(function (it) {
      if (!it || typeof it.title !== 'string') return;
      var u = typeof it.url === 'string' ? safeUrl(it.url) : null;
      if (!u || !/^\/products\//.test(u.pathname)) return;
      var card = document.createElement('div');
      card.className = 'mkpq__card';
      card.setAttribute('role', 'listitem');
      var imgBox = document.createElement('div');
      imgBox.className = 'mkpq__card-img';
      var src = typeof it.image === 'string' ? safeImg(it.image) : null;
      if (src) {
        var im = document.createElement('img');
        im.src = src; im.alt = it.title; im.loading = 'lazy';
        imgBox.appendChild(im);
      }
      card.appendChild(imgBox);
      var t = document.createElement('p');
      t.className = 'mkpq__card-title';
      t.textContent = it.title;
      card.appendChild(t);
      if (typeof it.price_fmt === 'string' && it.price_fmt) {
        var pr = document.createElement('p');
        pr.className = 'mkpq__card-price';
        pr.textContent = it.price_fmt;
        card.appendChild(pr);
      }
      if (Array.isArray(it.diffs) && it.diffs.length) {
        var ch = document.createElement('div');
        ch.className = 'mkpq__chips';
        it.diffs.slice(0, 3).forEach(function (d) {
          if (typeof d !== 'string' || !d) return;
          var c = document.createElement('span');
          c.className = 'mkpq__chip';
          c.textContent = d;
          ch.appendChild(c);
        });
        card.appendChild(ch);
      }
      if (typeof it.rating === 'string' && it.rating) {
        var rt = document.createElement('p');
        rt.className = 'mkpq__card-rating';
        rt.textContent = '\u2605 ' + it.rating;
        card.appendChild(rt);
      }
      if (it.available === false) {
        var na = document.createElement('p');
        na.className = 'mkpq__card-na';
        na.textContent = 'nicht lieferbar';
        card.appendChild(na);
      }
      var a = document.createElement('a');
      a.className = 'mkpq__card-btn';
      a.href = u.href;
      a.textContent = 'Ansehen';
      a.setAttribute('aria-label', 'Ansehen: ' + it.title);
      var handle = u.pathname.split('/')[2] || '';
      a.addEventListener('click', function () { ga('product_qa_card_click', { product_id: pid, target_handle: handle }); });
      card.appendChild(a);
      strip.appendChild(card);
    });
    return strip.children.length ? strip : null;
  }

  function render(el, text) {
    while (el.firstChild) el.removeChild(el.firstChild);
    var lines = String(text).replace(/\r/g, '').split('\n');
    var para = null, list = null;
    lines.forEach(function (line) {
      var m = /^\s*-\s+(.*)$/.exec(line);
      if (m) {
        para = null;
        if (!list) { list = document.createElement('ul'); el.appendChild(list); }
        var li = document.createElement('li');
        appendInline(li, m[1]);
        list.appendChild(li);
      } else {
        list = null;
        if (line.trim() === '') { para = null; return; }
        if (!para) { para = document.createElement('p'); el.appendChild(para); }
        else para.appendChild(document.createElement('br'));
        appendInline(para, line);
      }
    });
  }

  function trimChat() {
    while (chatEl.children.length > MAX_MSGS) chatEl.removeChild(chatEl.firstChild);
  }

  function scrollBottom(force) {
    if (!pScroll) return;
    if (force || stick) pScroll.scrollTop = pScroll.scrollHeight;
  }

  function showError(el, msg) {
    el.classList.add('is-error');
    render(el, msg || FRIENDLY);
  }

  /* ---------- Panel ---------- */
  function lockScroll() {
    if (locked) return;
    var b = document.body;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    savedBody = { position: b.style.position, top: b.style.top, width: b.style.width };
    b.style.position = 'fixed';
    b.style.top = (-lockY) + 'px';
    b.style.width = '100%';
    locked = true;
  }
  function unlockScroll() {
    if (!locked) return;
    var b = document.body;
    b.style.position = savedBody.position;
    b.style.top = savedBody.top;
    b.style.width = savedBody.width;
    locked = false;
    try { window.scrollTo({ top: lockY, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, lockY); }
  }

  /* iOS-Tastatur: Panel auf die sichtbare Viewport-Flaeche begrenzen, damit das Eingabefeld sichtbar bleibt. */
  function vvFit() {
    if (!isOpen()) return;
    var v = window.visualViewport;
    if (isDesk() || !v) { panel.style.height = ''; panel.style.top = ''; return; }
    panel.style.height = v.height + 'px';
    panel.style.top = v.offsetTop + 'px';
    scrollBottom(false);
  }

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent !== null; });
  }
  function onKey(e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (!isDesk() || panel.contains(document.activeElement)) { e.preventDefault(); closePanel(); }
      return;
    }
    if (e.key === 'Tab' && !isDesk()) {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (document.activeElement === first || document.activeElement === pTitle)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function ensurePanel() {
    if (panel) return;
    var frag = tpl.content.cloneNode(true);
    panel = frag.firstElementChild;
    document.body.appendChild(panel);
    chatEl = panel.querySelector('[data-mkpq-chat]');
    pScroll = panel.querySelector('[data-mkpq-scroll]');
    pPills = panel.querySelector('[data-mkpq-ppills]');
    pTitle = panel.querySelector('.mkpq-panel__title');
    var pForm = panel.querySelector('[data-mkpq-pform]');
    pInput = pForm.querySelector('input');
    pSend = pForm.querySelector('button');
    pScroll.setAttribute('tabindex', '-1');
    var dEl = panel.querySelector('[data-mkpq-date]');
    try { dEl.textContent = new Date().toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { dEl.textContent = ''; }
    pScroll.addEventListener('scroll', function () {
      stick = (pScroll.scrollHeight - pScroll.scrollTop - pScroll.clientHeight) < 40;
    });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-mkpq-close]'), function (b) { b.addEventListener('click', closePanel); });
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (ask(pInput.value, 'free', null, false, pInput)) pInput.value = '';
      else pInput.focus();
    });
    var cart = panel.querySelector('[data-mkpq-cart]');
    if (cart && !findForm()) { cart.parentNode.removeChild(cart); cart = null; }
    if (cart) cart.addEventListener('click', onCart);
    refreshCard();
    fillPills(pPills, 2);
    setBusy(busy);
  }

  /* ---------- Mini-Produktkarte: Variante, Warenkorb ---------- */
  var cartLocked = false;
  function findForm() {
    return document.querySelector('product-form:not([data-sticky]) form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }
  function currentVariant() {
    var f = findForm();
    var idEl = f && f.querySelector('input[name="id"]');
    var sc = document.querySelector('variant-selects script[type="application/json"]');
    if (!idEl || !idEl.value || !sc) return null;
    try {
      var arr = JSON.parse(sc.textContent);
      for (var i = 0; i < arr.length; i++) if (String(arr[i].id) === String(idEl.value)) return arr[i];
    } catch (e) { /* still */ }
    return null;
  }
  function refreshCard() {
    if (!panel) return;
    var priceEl = panel.querySelector('.mkpq-card__price');
    var btn = panel.querySelector('[data-mkpq-cart]');
    var v = currentVariant();
    if (v) {
      if (typeof v.price === 'number' && priceEl) {
        try { priceEl.textContent = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v.price / 100); } catch (e) { /* still */ }
      }
      if (btn && !cartLocked) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
    } else if (priceEl) {
      var pe = document.querySelector('[id^="price-"]');
      var t = pe ? pe.textContent.replace(/\s+/g, ' ').trim() : '';
      if (t && t.length < 40) priceEl.textContent = t;
    }
  }
  document.addEventListener('product:variant-change', refreshCard);

  function onCart() {
    var btn = this;
    if (cartLocked || btn.disabled) return;
    var f = findForm();
    if (!f) { btn.parentNode.removeChild(btn); return; }
    cartLocked = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var t0 = Date.now();
    if (f.requestSubmit) f.requestSubmit();
    else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    function finish() {
      var wrap = document.querySelector('.product-form__error-message-wrapper');
      var failed = !!(wrap && !wrap.hidden);
      if (!isDesk()) closePanel();
      if (failed) { try { wrap.scrollIntoView({ block: 'center' }); } catch (e) { /* still */ } }
      setTimeout(function () {
        cartLocked = false;
        btn.removeAttribute('aria-busy');
        refreshCard();
        if (!btn.disabled) return;
        var v = currentVariant();
        if (!v || v.available) btn.disabled = false;
      }, Math.max(0, 1500 - (Date.now() - t0)));
    }
    function poll() {
      var loading = document.querySelector('.single-add-to-cart-button.loading');
      if (loading && Date.now() - t0 < 5000) { setTimeout(poll, 100); return; }
      finish();
    }
    setTimeout(poll, 80);
  }

  /* ---------- inert fuer Seiteninhalt hinter dem modalen Mobil-Dialog ---------- */
  var inerted = [];
  function setInert() {
    if (inerted.length) return;
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === panel || /^(SCRIPT|STYLE|TEMPLATE|LINK|NOSCRIPT)$/.test(el.tagName)) return;
      if (el.inert) return;
      var id = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '');
      if (/cookie|consent|privacy-banner|shopify-pc/i.test(id)) return;
      el.inert = true;
      inerted.push(el);
    });
  }
  function clearInert() {
    inerted.forEach(function (el) { el.inert = false; });
    inerted = [];
  }

  function openPanel(trigger) {
    ensurePanel();
    loadTurnstile();
    if (isOpen()) return;
    lastTrigger = trigger || document.activeElement;
    var desk = isDesk();
    panel.setAttribute('aria-modal', desk ? 'false' : 'true');
    panel.hidden = false;
    if (!desk) { lockScroll(); setInert(); }
    refreshCard();
    document.addEventListener('keydown', onKey);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', vvFit);
      window.visualViewport.addEventListener('scroll', vvFit);
    }
    vvFit();
    stick = true;
    scrollBottom(true);
    ga('product_qa_open', { product_id: pid });
    try {
      if (desk) pInput.focus({ preventScroll: true });
      else pTitle.focus({ preventScroll: true });
    } catch (e) { /* still */ }
  }

  function closePanel() {
    if (!isOpen()) return;
    panel.hidden = true;
    panel.style.height = '';
    panel.style.top = '';
    unlockScroll();
    clearInert();
    document.removeEventListener('keydown', onKey);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', vvFit);
      window.visualViewport.removeEventListener('scroll', vvFit);
    }
    var t = lastTrigger;
    if (!(t && document.documentElement.contains(t) && !t.disabled && t.offsetParent !== null)) t = !resumeBtn.hidden ? resumeBtn : input;
    try { t.focus({ preventScroll: true }); } catch (e) { /* still */ }
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      if (!isOpen()) return;
      if (isDesk()) { unlockScroll(); clearInert(); panel.setAttribute('aria-modal', 'false'); }
      else { lockScroll(); setInert(); panel.setAttribute('aria-modal', 'true'); }
      vvFit();
    });
  }

  /* ---------- Frage stellen ---------- */
  /* Worker lehnt Bodies > 8 KB ab: aelteste History-Eintraege weglassen, bis <= 7500 Bytes. */
  function buildBody(question) {
    var h = hist.slice(-3), body;
    for (;;) {
      body = JSON.stringify({ product_id: pid, question: question, history: h });
      if (h.length === 0 || new TextEncoder().encode(body).length <= 7500) return body;
      h = h.slice(1);
    }
  }

  /* ---------- Turnstile (optional, nur mit Sitekey) + Sitzungstoken (nur im Speicher) ---------- */
  var tsKey = root.getAttribute('data-turnstile') || '';
  var tsLoading = null, tsWid = null, tsToken = '', tsWait = null, qaSession = '';
  var VERIFY_MSG = 'Die Sicherheitsprüfung ist fehlgeschlagen. Bitte lade die Seite neu und versuch es noch einmal.';
  function loadTurnstile() {
    if (!tsKey || tsLoading) return tsLoading;
    tsLoading = new Promise(function (resolve) {
      function ready() {
        try {
          var box = document.createElement('div');
          box.className = 'mkpq-ts';
          (panel || document.body).appendChild(box);
          tsWid = window.turnstile.render(box, {
            sitekey: tsKey, execution: 'execute', appearance: 'interaction-only',
            callback: function (t) { tsToken = t; if (tsWait) { var w = tsWait; tsWait = null; w(t); } },
            'error-callback': function () { if (tsWait) { var w = tsWait; tsWait = null; w(''); } },
            'expired-callback': function () { tsToken = ''; }
          });
        } catch (e) { /* ohne Turnstile weiter */ }
        resolve();
      }
      if (window.turnstile) { ready(); return; }
      var sc = document.createElement('script');
      sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      sc.async = true; sc.defer = true;
      sc.onload = ready;
      sc.onerror = function () { resolve(); };
      document.head.appendChild(sc);
    });
    return tsLoading;
  }
  function resetTurnstile() {
    qaSession = ''; tsToken = '';
    try { if (tsWid !== null && window.turnstile) window.turnstile.reset(tsWid); } catch (e) { /* still */ }
  }
  /* Liefert zusaetzliche Request-Header: Sitzung bei Folgefragen, sonst Turnstile-Token. */
  function authHeaders() {
    if (qaSession) return Promise.resolve({ 'X-QA-Session': qaSession });
    if (!tsKey) return Promise.resolve({});
    return (loadTurnstile() || Promise.resolve()).then(function () {
      if (tsWid === null || !window.turnstile) return {};
      if (tsToken) { var t0 = tsToken; tsToken = ''; return { 'X-Turnstile-Token': t0 }; }
      return new Promise(function (resolve) {
        var done = false;
        var to = setTimeout(function () { if (!done) { done = true; tsWait = null; resolve({}); } }, 12000);
        tsWait = function (t) { if (done) return; done = true; clearTimeout(to); tsToken = ''; resolve(t ? { 'X-Turnstile-Token': t } : {}); };
        try { window.turnstile.execute(tsWid); } catch (e) { tsWait(''); }
      });
    });
  }

  /* Gibt true zurueck, wenn die Frage gesendet wurde. */
  function ask(question, source, sugg, kbd, trigger) {
    question = (question || '').trim();
    if (busy) return false;
    if (question.length < 3 || question.length > 300) return false;
    if (sugg) sugg.used = true;
    asked++;
    track(source);
    openPanel(trigger);
    renderPills();
    setBusy(true);

    var q = document.createElement('div');
    q.className = 'mkpq__q';
    q.textContent = question;
    var a = document.createElement('div');
    a.className = 'mkpq__a';
    a.textContent = 'Einen Moment …';
    chatEl.appendChild(q);
    chatEl.appendChild(a);
    trimChat();
    stick = true;
    scrollBottom(true);

    var text = '', gotDelta = false, failed = false, hide = false, gotDone = false, errMsg = '', sig = '', cardsEl = null, verifyFail = false, retried = false;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { failed = true; if (ctrl) ctrl.abort(); }, TIMEOUT_MS);

    function handle(raw) {
      var line = raw.trim();
      if (line.indexOf('data:') !== 0) return;
      var ev;
      try { ev = JSON.parse(line.slice(5)); } catch (e) { return; }
      if (ev.type === 'delta' && typeof ev.text === 'string') {
        gotDelta = true;
        text += ev.text;
        render(a, text);
        scrollBottom(false);
      } else if (ev.type === 'cards' && Array.isArray(ev.items) && !cardsEl) {
        cardsEl = buildCards(ev.items);
        if (cardsEl) { a.parentNode.insertBefore(cardsEl, a.nextSibling); scrollBottom(false); }
      } else if (ev.type === 'done') {
        gotDone = true;
        if (typeof ev.sig === 'string') sig = ev.sig;
        if (typeof ev.qa_session === 'string' && ev.qa_session) qaSession = ev.qa_session;
      } else if (ev.type === 'error') {
        failed = true;
        if (ev.code === 'verify') verifyFail = true;
        if (ev.code === 'rate_limited') {
          errMsg = (typeof ev.message === 'string' && ev.message.trim()) ? ev.message.trim() : RATE;
        }
      }
    }
    function addNote() {
      var n = document.createElement('p');
      n.className = 'mkpq__note';
      n.textContent = INTERRUPTED;
      a.appendChild(n);
    }

    function run() {
    return authHeaders().then(function (ah) {
      var hd = { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' };
      for (var k in ah) hd[k] = ah[k];
      return fetch(base + '/ask', { method: 'POST', headers: hd, body: buildBody(question), signal: ctrl ? ctrl.signal : undefined });
    }).then(function (res) {
      if (res.status === 403) { verifyFail = true; failed = true; return; }
      if (res.status === 503) { hide = true; throw new Error('http 503'); }
      if (res.status === 429) { errMsg = RATE; throw new Error('http 429'); }
      if (!res.ok) throw new Error('http ' + res.status);
      if (!res.body || !res.body.getReader) {
        return res.text().then(function (t) { t.split('\n').forEach(handle); });
      }
      var reader = res.body.getReader();
      var dec = new TextDecoder('utf-8');
      var buf = '';
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) { buf += dec.decode(); if (buf) buf.split('\n').forEach(handle); return; }
          buf += dec.decode(r.value, { stream: true });
          var idx;
          while ((idx = buf.indexOf('\n')) >= 0) {
            handle(buf.slice(0, idx));
            buf = buf.slice(idx + 1);
          }
          return pump();
        });
      }
      return pump();
    });
    }
    run().then(function () {
      if (verifyFail && !retried && !gotDelta) {
        retried = true; verifyFail = false; failed = false; resetTurnstile();
        return run();
      }
    }).then(function () {
      if (verifyFail && !gotDelta) errMsg = VERIFY_MSG;
      if (!gotDelta) { if (cardsEl && !failed) a.parentNode.removeChild(a); else showError(a, errMsg); }
      else if (failed || !gotDone) addNote();
      else hist.push({ q: question, a: text, sig: sig });
    }).catch(function () {
      if (hide) { root.hidden = true; closePanel(); return; }
      if (!gotDelta) { if (cardsEl) a.parentNode.removeChild(a); else showError(a, errMsg); } else addNote();
    }).then(function () {
      clearTimeout(timer);
      setBusy(false);
      scrollBottom(false);
      if (source === 'suggested' && isOpen()) {
        try {
          if (kbd) pInput.focus({ preventScroll: true });
          else pScroll.focus({ preventScroll: true });
        } catch (e) { /* still */ }
      }
    });
    return true;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (ask(input.value, 'free', null, false, input)) input.value = '';
    else input.focus();
  });
  resumeBtn.addEventListener('click', function () { openPanel(resumeBtn); });

  function start() {
    if (started) return;
    started = true;
    fetch(base + '/questions?product_id=' + encodeURIComponent(pid), { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (res.status === 503) { root.hidden = true; return null; }
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        (data.questions || []).slice(0, 3).forEach(function (s) {
          if (typeof s === 'string' && s.trim()) suggestions.push({ label: s.trim(), used: false });
        });
        renderPills();
      })
      .catch(function () { /* nur Eingabefeld */ })
      .then(function () { pillsEl.classList.remove('is-loading'); });
  }

  pillsEl.classList.add('is-loading');
  root.hidden = false;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); start(); }
    }, { rootMargin: '200px 0px' });
    io.observe(root);
  } else {
    start();
  }
})();
